import { cn } from '@/lib/utils';
import {
  buttonStyles,
  type ButtonStyleSize,
  type ButtonStyleVariant,
  type ButtonVariantProps,
} from './button-styles';

export type ButtonVariant = ButtonStyleVariant;
export type ButtonSize = ButtonStyleSize;

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, ButtonVariantProps {
  ref?: React.Ref<HTMLButtonElement>;
}

export function Button({ className, variant, size, type = 'button', ref, ...props }: ButtonProps) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(buttonStyles({ variant, size }), className)}
      {...props}
    />
  );
}

Button.displayName = 'Button';
